<template>
	<div class="pages" >
		<div class="index-wapper">
			<!--menu-->
			<aside class="nav" :class="{'close':switchOff}">
				<!--<a @click="handleSwitch" class="switch b-r-3 fx-align icon-menu" ></a>-->
				<z-menu></z-menu>
			</aside>
			<header :class="{'close':switchOff}" class="hearder-top fx fx-x-between fx-y-center">
				<div class="fx fx-y-center">
					<a @click="handleSwitch" class="switch icon-menu-l "></a>
				</div>
				<div class="user-operation">
					<!--<router-link :to="{ name: 'msgCenter'}" class="news"><i class="icon-news m-r-5"></i>消息<em></em></router-link>
					<router-link :to="{ name: 'helpCenter'}"><i class="icon-help m-r-5"></i>帮助</router-link>-->
					<!--<router-link :to="{ name: 'userCenter'}"><i class="icon-set m-r-5"></i>设置</router-link>
					<a @click="handleOutLogin"><i class="icon-out m-r-5"></i>退出</a>-->
					<a @click="handleOutLogin"><i class="icon-out m-r-5"></i>退出</a>
				</div>
			</header>
			<!--<div class="guide-words" v-show="!info.id">
				<span>亲！您还没有接入微信公众号，部分功能将无法使用。</span>
				<router-link :to="{ name: 'memberPubilc' }" class="link-style">立即接入>></router-link>
			</div>-->
			<article :class="{'close':switchOff}" class="container">
				<transition name="fade" mode="out-in">
					<router-view class="view"></router-view>
				</transition>
			</article>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	
	import Menu from "./Menu.vue";
	export default {
		name: 'main',
		components: {
			"z-menu": Menu,
		},
		data() {
			return {
				isShow:false, //获取用户信息成功
				switchOff: false
			}
		},
		mounted (){
		    this.handleGetUserInfo()
//		    this.handleGetMemberPublic()
	    },
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo,
//				info: state => state.adminMemberPublic.info
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleGetUserInfo(){//获取用户信息
				this.getUserInfo().then(()=>{
					this.$log('获取用户信息成功')
					this.isShow = true
				},(err)=>{
					this.$log(err)
				})
			},
			async handleOutLogin() { //退出登录
				try {
					await this.$confirm(`确定要退出?`)
					await this.outLogin()
					this.$router.replace({
						name: 'login'
					})
				} catch(e) {
					this.$log(e)
				}
			},
			handleSwitch() {
				this.switchOff = this.switchOff ? false : true
			},
			...mapActions(['getUserInfo','getMemberPublic','outLogin'])
		}

	}
</script>

<style lang="scss">
	@import "src/assets/css/common.scss";
	/*.view {
		transition: opacity .2s ease;
		opacity: 1;
	}

	.view.v-enter,
	.view.v-leave {
		opacity: 0
	}*/
	.index-wapper{
		position: relative;
	}
	.guide-words{
		position: fixed;
		left: px-em(560px);
		top: px-em(24px);
		z-index: 98;
	}
	.nav {
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		height: 100%;
		width: px-em(440px);
		z-index: 99;
		transform: translateX(0);
		-webkit-transform: translateX(0);
		transition: all 0.25s ease;
		-webkit-transition: all 0.25s ease;
		&.close {
			transform: translateX(-440px);
			-webkit-transform: translateX(-440px);
		}
	}
	
	.hearder-top {
		background: $color-gray;
		height: px-em(88px);
		position: fixed;
		top: 0;
		left: px-em(440px);
		right: 0;
		z-index: 98;
		padding-right: px-em(40px);
		transition: all 0.25s ease;
		-webkit-transition: all 0.25s ease;
		.switch {
			height: px-em(90px);
			line-height: px-em(90px);
			padding: 0 px-em(40px);
			display: block;
			color: $color-main;
			cursor: pointer;
			font-size: 18px;
			transform: rotate(0);
			-webkit-transform: rotate(0);
			transition: all 0.25s ease;
			-webkit-transition: all 0.25s ease;
			&:hover {
				transform: scale(1.1);
				-webkit-transform: scale(1.1);
			}
		}
		&.close{
			left: 0;
			.switch{
				transform: rotate(-180deg);
				-webkit-transform: rotate(-180deg);
				&:hover{
					transform: scale(1.1) rotate(-180deg);
					-webkit-transform: scale(1.1) rotate(-180deg);
				}
			}
		}
		.user-operation {
			a{
				margin-left: px-em(40px);
			}
			a:hover {
				color: $color-main;
				.icon{
					color: $color-main;
				}
			}
			.icon{
				font-size: px-em(24px);
				transition: all 0.2s ease;
			}
			.news{
				position: relative;
				em{
					position: absolute;
					top: -4px;
					right: -6px;
					width: 8px;
					height: 8px;
					background: $color-red;
					border-radius: 50%;
					-webkit-border-radius: 50%;
				}
			}
		}
	}
	.container {
		/*min-width: px-em(1600px) !important;*/
    	overflow-x: auto;
		padding: px-em(128px) px-em(40px) px-em(280px) px-em(480px);
		-webkit-transition: all 0.2s ease;
		&.close {
			padding-left: px-em(40px);
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.nav {
			width: px-em(300px);
			-webkit-transform: translateX(px-em(-300px));
			&.close {
				-webkit-transform: translateX(px-em(0px));
			}
			.user-info{
				padding: px-em(20px) !important;
			}
		}
		.container {
			padding: px-em(110px) px-em(20px) px-em(40px);
		}
		.hearder-top {
			left: 0;
			&.close {
				left: px-em(300px);
			}
		}
		.user-operation {
			a{
				margin-left: px-em(0) !important;
				padding-left: px-em(20px) !important;
			}
		}
		.guide-words{
			width: 100%;
			position: relative;
			left: px-em(20px);
			top: px-em(100px);
			z-index: 88;
		}
	}
</style>


// WEBPACK FOOTER //
// Main.vue?23cd50e9